import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface DataTypeDoc {
  id: string;
  slug: string;
  name: string;
  category: string;
  icon: string;
  short_description: string | null;
  content: string;
  example_value: string | null;
  regex_pattern: string | null;
  display_order: number;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export function useDataTypeDocs() {
  return useQuery({
    queryKey: ['data-type-docs'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('data_type_docs')
        .select('id, slug, name, category, icon, short_description, example_value, display_order, is_active')
        .eq('is_active', true)
        .order('display_order', { ascending: true });

      if (error) throw error;
      return data as DataTypeDoc[];
    },
    staleTime: 10 * 60 * 1000, // 10 minutes - static reference data
  });
}

export function useDataTypeDoc(slug: string) {
  return useQuery({
    queryKey: ['data-type-doc', slug],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('data_type_docs')
        .select('id, slug, name, category, icon, short_description, content, example_value, regex_pattern, display_order, is_active, created_at, updated_at')
        .eq('slug', slug)
        .eq('is_active', true)
        .single();

      if (error) throw error;
      return data as DataTypeDoc;
    },
    staleTime: 10 * 60 * 1000, // 10 minutes - static reference data
    enabled: !!slug,
  });
}

